import { Link as FluentLink } from '@fluentui/react-components';

import { TDocument } from '@modules/documents';
import { TFile } from '@modules/files';
import { TInlineBlock } from '@modules/inlineBlocks';
import { EItemScreenMode, useItemScreenStore } from '@modules/items';

type TProps = {
  item: TDocument | TFile | TInlineBlock;
  setIsDialogOpen: (isDialogOpen: boolean) => void;
};

const UnresolvedCommentsWarning = ({ item, setIsDialogOpen }: TProps) => {
  const { setScreenMode } = useItemScreenStore();

  const numUnresolvedComments = item.comments.filter(
    (comment) => !comment.resolvedDate && comment.versionMode === 'AUTO'
  );
  if (numUnresolvedComments.length <= 0) return null;
  return (
    <div className="flex space-x-2 mb-2">
      <p className="font-bold">
        {numUnresolvedComments.length === 1
          ? '1 comment is unresolved:'
          : `${numUnresolvedComments.length} comments are unresolved:`}
      </p>
      <FluentLink
        onClick={() => {
          setScreenMode(EItemScreenMode.COMMENTS);
          setIsDialogOpen(false);
        }}
      >
        Show (closes dialog)
      </FluentLink>
    </div>
  );
};

export default UnresolvedCommentsWarning;
